<template>
    <div>
        <div class="row step" v-if="!isBackwards">
            <div class="col-4 overflow-hidden position-relative h-1">
                <div class="vertical-line position-absolute"></div>
            </div>
        </div>
        <div class="row step">
            <div class="col-4 overflow-hidden position-relative">
                <div class="time d-flex align-items-center justify-content-end">
                    <div class="circle-icon ml-2 bg-white">
                        <svg-icon class="circle-icon-svg" name="three-dots" height="auto" width="20"/>
                    </div>
                </div>
                <div class="vertical-line position-absolute"></div>
            </div>
            <div class="col-8 d-flex pl-0">
                <button @click="onClick(direction)" type="button" class="btn btn-outline-dark">View {{ directionText }} stage</button>
            </div>
            <div v-if="isBackwards" class="col-4 overflow-hidden position-relative h-1">
                <div class="vertical-line position-absolute"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'navigation-item',
    props: ['direction'],
    data() {
        return {
        }
    },
    computed: {
        directionText() {
            return this.isBackwards ? 'previous' : 'next'
        },
        isBackwards() {
            return this.direction === 'backwards'
        },
    },
    methods: {
        onClick(direction) {
            this.$emit('click', direction)
        },
    },
}
</script>
